import { render, staticRenderFns } from "./ParcelDetailCard.vue?vue&type=template&id=946bc050&scoped=true&"
import script from "./ParcelDetailCard.vue?vue&type=script&lang=js&"
export * from "./ParcelDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetailCard.vue?vue&type=style&index=0&id=946bc050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946bc050",
  null
  
)

export default component.exports